import { useRef, useEffect } from "react";

const TextAreaField = ({
  label,
  placeholder = "Type here...",
  value = "",
  onChange,
  name,
  disabled = false,
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto"; 
    el.style.height = `${el.scrollHeight}px`; 
  }, [value]);

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="font-semibold text-text-primary">{label}</label>
      )}
      <textarea
        ref={textareaRef}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={3} 
        disabled={disabled}
        className={`p-3 resize-none outline-none 
         border border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-primary text-sm 
         text-text-primary placeholder:text-text-muted
         ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
      />
    </div>
  );
};

export default TextAreaField;
